import { useContext, useEffect } from "react";
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
  ModalBody,
  Modal,
} from "reactstrap";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "../../../components/Icon/Icon";
import PaginationComponent from "../../../components/Pagination/Pagination";
import TableFilter from "../../../components/TableFilter/TableFilter";
import UserAvatar from "../../../components/UserAvatar/UserAvatar";
import PageHeader from "../../../components/PageHeader/PageHeader";
import SearchTable from "../../../components/SearchTable/SearchTable";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import UserInfoItem from "../../../components/UserInfoItem/UserInfoItem";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import SpecialIcon from "../../../helpers/SpecialIcon/SpecialIcon";
import { Col, Row } from "../../../components/Grid/Grid";
import { Block } from "../../../components/Block/Block";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/DataTable/DataTable";
import { convertDate } from "../../../utils";
import { transactionUserContext } from "./../../../context/UserContext/TransactionUserContext/TransactionUserContext";
import {
  convertTransactionTypeToColor,
  convertTransactionTypeToText,
} from "../../../utils/enum";

const TransactionsUser = () => {
  const { user } = useParams();

  const {
    transactions,
    transaction,
    setTransaction,
    filter,
    setFilter,
    sort,
    setSort,
    start,
    setStart,
    end,
    setEnd,
    status,
    setStatus,
    pageCount,
    itemsCount,
    setItemsCount,
    pageNumber,
    setPageNumber,
    handleGetTransactions,
  } = useContext(transactionUserContext);

  useEffect(() => {
    handleGetTransactions();
  }, [start, end, pageNumber, itemsCount, sort, user]);

  return (
    <>
      <SiteTitle title="تراکنشات" />

      <PageHeader title="تراکنشات" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
        setStart={setStart}
        start={start}
        setEnd={setEnd}
        end={end}
        setTransactionStatus={setStatus}
        transactionStatus={status}
      />

      <Block>
        <DataTable className="card-stretch">
          <SearchTable
            filterPlaceholder="کدپیگیری، توضیحات و..."
            filter={filter}
            setFilter={setFilter}
            onSearch={handleGetTransactions}
          />
          <DataTableBody>
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text">#</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">کاربر</span>
              </DataTableRow>
              <DataTableRow size="mb">
                <span className="sub-text">
                  مبلغ <Currency />
                </span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">کاربر ایجاد کننده</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">نوع</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">کد پیگیری</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">تاریخ</span>
              </DataTableRow>
              <DataTableRow />
            </DataTableHead>
            {/*Head*/}
            {transactions.length > 0
              ? transactions.map((item, index) => {
                  return (
                    <DataTableItem key={item._id}>
                      <DataTableRow>
                        <span>{index + 1}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="user-card">
                          <UserAvatar
                            {...(item?.user?.avatar
                              ? { image: item?.user?.avatar }
                              : {
                                  icon: "user-alt",
                                })}
                          />
                          <UserInfoItem
                            title={`${item?.user?.firstName} ${item?.user?.lastName}`}
                            subTitle={item?.user?.phoneNumber}
                            titleSuffix={item?.user?.isVIP && <SpecialIcon />}
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow size="mb">
                        <span>
                          <ConvertCurrency price={item.amount} />
                        </span>
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <div className="user-card">
                          <UserAvatar
                            {...(item?.creator?.avatar
                              ? { image: item?.creator?.avatar }
                              : {
                                  icon: "user-alt",
                                })}
                          />
                          <UserInfoItem
                            title={`${item?.creator?.firstName} ${item?.creator?.lastName}`}
                            subTitle={item?.creator?.phoneNumber}
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <Badge
                          className="badge-dim"
                          color={convertTransactionTypeToColor(item.type)}
                        >
                          {convertTransactionTypeToText(item.type)}
                        </Badge>
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>{item.trackingCode}</span>
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>
                          {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm:ss")}
                        </span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-h" />
                              </DropdownToggle>
                              <DropdownMenu left>
                                <ul className="link-list-opt no-bdr text-right">
                                  <li onClick={() => setTransaction(item)}>
                                    <DropdownItem tag="a" type="button">
                                      <Icon name="info" />
                                      <span>جزئیات</span>
                                    </DropdownItem>
                                  </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                    </DataTableItem>
                  );
                })
              : null}
          </DataTableBody>
          <div className="card-inner">
            {transactions.length > 0 ? (
              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">داده ای برای نمایش یافت نشد</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>

      <Modal
        isOpen={!isEmpty(transaction)}
        toggle={() => setTransaction({})}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => setTransaction({})}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">جزئیات تراکنش</h5>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات کاربر
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="نام">
                  {transaction?.user?.firstName}{" "}
                  {transaction?.user?.isVIP && <SpecialIcon />}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام خانوادگی">
                  {transaction?.user?.firstName}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره موبایل">
                  {transaction?.user?.phoneNumber}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ تولد">
                  {convertDate(transaction?.user?.birthDate)}
                </InfoItem>
              </Col>
            </Row>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات کاربر ایجاد کننده
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="نام">
                  {transaction?.creator?.firstName}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام خانوادگی">
                  {transaction?.creator?.firstName}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره موبایل">
                  {transaction?.creator?.phoneNumber}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ تولد">
                  {convertDate(transaction?.creator?.birthDate)}
                </InfoItem>
              </Col>
            </Row>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات تراکنش
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="مبلغ">
                  <ConvertCurrency price={transaction?.amount} /> <Currency />
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="کد پیگیری">
                  {transaction?.trackingCode}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ">
                  {convertDate(transaction?.createdAt, "YYYY/MM/DD - HH:mm:ss")}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نوع">
                  <Badge
                    className="badge-dim"
                    color={convertTransactionTypeToColor(transaction?.type)}
                  >
                    {convertTransactionTypeToText(transaction?.type)}
                  </Badge>
                </InfoItem>
              </Col>
              <Col size="12">
                <InfoItem title="توضیحات">{transaction?.description}</InfoItem>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default TransactionsUser;
